// extracted by mini-css-extract-plugin
export var active = "_c6-7";
export var container = "_c6-0";
export var evenWidth = "_c6-4";
export var large = "_c6-5";
export var outlet = "_c6-8";
export var slide = "_c6-2";
export var small = "_c6-6";
export var tab = "_c6-3";
export var tabs = "_c6-1";